// src/pages/homepage.js
import React from "react";

export default function Homepage() {
  return (
    <div className="bg-white text-gray-900">
      {/* Hero Section */}
      <section className="bg-gray-900 text-white py-20 px-6">
        <div className="max-w-7xl mx-auto text-center">
          <h1 className="text-4xl md:text-6xl font-bold mb-6">
            Elevate Your Team's Cybersecurity Skills
          </h1>
          <p className="text-lg md:text-xl mb-8">
            Hands-on training platform designed for companies under NIS2 compliance.
          </p>
          <a
            href="/contact"
            className="inline-block bg-green-500 hover:bg-green-600 text-white font-semibold px-8 py-3 rounded-xl transition"
          >
            Request a Demo
          </a>
        </div>
      </section>

      {/* Benefits Section */}
      <section className="py-20 px-6 bg-gray-50">
        <div className="max-w-6xl mx-auto grid md:grid-cols-3 gap-10 text-center">
          <div>
            <div className="text-green-600 text-5xl mb-4">🛡️</div>
            <h3 className="text-xl font-semibold mb-2">NIS2-Aligned Courses</h3>
            <p>Custom-built content tailored for EU cybersecurity regulations.</p>
          </div>
          <div>
            <div className="text-green-600 text-5xl mb-4">⚙️</div>
            <h3 className="text-xl font-semibold mb-2">Easy Deployment</h3>
            <p>No technical setup. Your team can start learning in minutes.</p>
          </div>
          <div>
            <div className="text-green-600 text-5xl mb-4">📊</div>
            <h3 className="text-xl font-semibold mb-2">Progress Tracking</h3>
            <p>Monitor team engagement and performance with detailed reports.</p>
          </div>
        </div>
      </section>

      {/* How It Works */}
      <section className="py-20 px-6 bg-white">
        <div className="max-w-5xl mx-auto text-center">
          <h2 className="text-3xl font-bold mb-12">How It Works</h2>
          <div className="grid md:grid-cols-3 gap-10">
            <div>
              <div className="text-green-500 text-4xl mb-4">1️⃣</div>
              <h4 className="text-xl font-semibold mb-2">Create Organization</h4>
              <p>Register your company and set up your admin dashboard.</p>
            </div>
            <div>
              <div className="text-green-500 text-4xl mb-4">2️⃣</div>
              <h4 className="text-xl font-semibold mb-2">Invite Employees</h4>
              <p>Send email invites or upload a list to onboard users fast.</p>
            </div>
            <div>
              <div className="text-green-500 text-4xl mb-4">3️⃣</div>
              <h4 className="text-xl font-semibold mb-2">Track & Report</h4>
              <p>Access dashboards and compliance reports in real-time.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section className="bg-gray-900 text-white py-20 px-6">
        <div className="max-w-5xl mx-auto text-center">
          <h2 className="text-3xl font-bold mb-12">You're in good company</h2>
          <div className="grid md:grid-cols-3 gap-10 text-center">
            <div>
              <div className="text-5xl font-bold mb-2">250+</div>
              <p>Companies Trained</p>
            </div>
            <div>
              <div className="text-5xl font-bold mb-2">5,000+</div>
              <p>Active Learners</p>
            </div>
            <div>
              <div className="text-5xl font-bold mb-2">98%</div>
              <p>Completion Rate</p>
            </div>
          </div>
        </div>
      </section>

      {/* Final CTA */}
      <section className="py-20 px-6 bg-green-500 text-white text-center">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-3xl font-bold mb-6">Ready to secure your workforce?</h2>
          <a
            href="/contact"
            className="bg-white text-green-600 font-semibold px-8 py-3 rounded-xl hover:bg-gray-100 transition"
          >
            Get in touch
          </a>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-800 text-gray-400 py-8 px-6 text-center">
        <p className="text-sm">© {new Date().getFullYear()} Geekbit Academy. All rights reserved.</p>
      </footer>
    </div>
  );
}

